import { render, staticRenderFns } from "./scene0.vue?vue&type=template&id=6dbe69d3&scoped=true&"
import script from "./scene0.vue?vue&type=script&lang=ts&"
export * from "./scene0.vue?vue&type=script&lang=ts&"
import style0 from "./scene0.vue?vue&type=style&index=0&id=6dbe69d3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe69d3",
  null
  
)

export default component.exports